import { Button } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

interface FeedbackButtonsProps {
  onSubmit: () => Promise<void>;
  onSkip: () => void;
  isSubmitButtonDisabled?: boolean;
  isSubmitting?: boolean;
}

export function FeedbackButtons({
  onSkip,
  onSubmit,
  isSubmitButtonDisabled = false,
  isSubmitting = false,
}: FeedbackButtonsProps): JSX.Element {
  const { t } = useTranslation();
  const disabled = isSubmitButtonDisabled || isSubmitting;

  return (
    <div className="flex flex-row pt-5 pb-1.25">
      <div className="w-1/2 pr-1.25">
        <Button backgroundColor="white" forgroundColor="black" showBorder onClick={onSkip} disabled={isSubmitting}>
          {t("feedbackModal.skipSurveyBT")}
        </Button>
      </div>
      <div className="w-1/2 pl-1.25">
        <Button
          onClick={() => {
            void onSubmit();
          }}
          disabled={disabled}
          loading={isSubmitting}
        >
          {t("button.submit")}
        </Button>
      </div>
    </div>
  );
}
